<template>
  <div class="app min-h-screen">
    <ConcertsHeader v-if="!eventPageStore.isLoading" />
    <Toast />
    <router-view />
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import Toast from "primevue/toast";
import ConcertsHeader from "./components/ConcertsHeader.vue";
import { useThemeStore } from "./stores/theme";
import { useDeviceStore } from "./stores/device";
import { useConcertsStyleStore } from "./stores/concertsStyle";
import { useEventPageStore } from "./stores/eventPage";

const themeStore = useThemeStore();
const deviceStore = useDeviceStore();
const concertsStyleStore = useConcertsStyleStore();
const eventPageStore = useEventPageStore();

onMounted(() => {
  themeStore.initTheme();
  deviceStore.initDeviceId();
  concertsStyleStore.resetToDefault();
});
</script>

<style>
#app,
.app {
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    "Helvetica Neue",
    Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "cv02", "cv03", "cv04", "cv11";
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>
